export const step = (from: number, to: number): number => (to - from) / 1000 / 1000
